// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index__container__3qBLr {\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/Layout/index.less"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".container {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "index__container__3qBLr"
};
export default ___CSS_LOADER_EXPORT___;
